
<template>
  <div>  
    <slot></slot>
    <div v-if="show" :id="'vue-popper-'+popperId" class="vue-popper-component">
      <button
        v-if="closeButton"
        @click="$emit('close')"
        :id="'vue-popper-'+popperId+'-close'"
        type="button"
        class="js-popper-close popper-close"
      >
        <slot name="close-button">{{ closeButton }}</slot>
      </button>

      <slot name="content">{{ content }}</slot>

      <div class="popper__arrow" x-arrow></div>
    </div>
  </div>
</template>

<script> 
import { mapGetters, mapMutations } from "vuex";
import Popper from 'popper.js';

export default {
  props: {
    showPopper: {
      type: Boolean,
      required: false,
      default: false
    },
    placement: {
      type: String,
      required: false,
      default: "top"
    },
    content: {
      type: String,
      required: false,
      default: ""
    },
    closeButton: {
      type: String,
      required: false,
      default: null
    },
    index: {
      type: Number,
      required: false,
      default: 0
    }
  },

  data() {
    return {
      popperId: null,
      popper: null,
      show: false,
    };
  },

  ready() {
    this.$nextTick(() => { 
      if (this.showPopper) {
        this.initPopper();
      }
    });
  },  
  computed: {
    ...mapGetters({
      destroy: "customComponentModule/getDestroy",
      activeIndex: "customComponentModule/getActiveIndex"
    }), 
  },
  mounted () { 
    if (this.index === 0) { 
      this.show = this.showPopper; 
      if (this.showPopper) {
        this.$nextTick(() => {
          this.initPopper();
        });
      }
    }
    if (this.index === this.activeIndex) {
      this.show = true;  
        this.$nextTick(() => {
          this.initPopper();
        });
    } 
  },

  watch: {
    showPopper(val, oldVal) {
      this.show = this.showPopper; 
      if (this.showPopper) {
        this.$nextTick(() => {
          this.initPopper();
        });
      }
    }, 
    index(val, oldVal) {
      console.log(val, oldVal); 
    }
  },

  destroyed() { 
    this.destroyPopper();
  },

  methods: {
    ...mapMutations({
      setDestroy: "customComponentModule/setDestroy",
    }),
    initPopper() {
      this.setDestroy(false);
      this.popperId = this.uuid4();
      this.popper = new Popper(
        this.$el,
        this.$el.querySelector(".vue-popper-component"),
        {
          placement: this.placement || "bottom",
          removeOnDestroy: true
        }
      );
    },

    destroyPopper() {
        this.popper = null;  
    },

    uuid4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
        let r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
  }
};
</script>


<style lang="scss">
$popper-background-color: #fff !default;

.vue-popper-component {
  background: #fff;
  color: black;
  width: 547px;  
  border-radius: 3px;
  z-index: 1000; 
	box-shadow: 0px 0px 10px 0px 
		rgba(0, 0, 0, 0.2);

  .popper-close {
    position: absolute;
    top: 2px;
    right: 4px;
    color: black;
    background: transparent;
    border: none;

    &:active,
    &:focus {
      outline: none;
    }
  }

  .popper__arrow {
    width: 0;
    height: 0;
    border-style: solid;
    position: absolute;
    margin: 5px;
  }

  &[x-placement^="top"] {
    margin-bottom: 5px;

    .popper__arrow {
      border-width: 5px 5px 0 5px;
      border-color: $popper-background-color transparent transparent transparent;
      bottom: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="bottom"] {
    margin-top: 5px;

    .popper__arrow {
      border-width: 0 5px 5px 5px;
      border-color: transparent transparent $popper-background-color transparent;
      top: -5px;
      left: calc(50% - 5px);
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  &[x-placement^="right"] {
    margin-left: 55px;

    .popper__arrow {
      border-width: 5px 5px 5px 0;
      border-color: transparent $popper-background-color transparent transparent;
      left: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }

  &[x-placement^="left"] {
    margin-right: 5px;

    .popper__arrow {
      border-width: 5px 0 5px 5px;
      border-color: transparent transparent transparent $popper-background-color;
      right: -5px;
      top: calc(50% - 5px);
      margin-left: 0;
      margin-right: 0;
    }
  }
}
</style>